"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_popper_1 = require("react-popper");

var base_ui_1 = require("@jonny/base-ui");

var default_1 =
/** @class */
function (_super) {
  __extends(default_1, _super);

  function default_1() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      tooltip: false
    };
    return _this;
  }

  default_1.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        tip = _a.tip,
        preferredPlacement = _a.preferredPlacement,
        _b = _a.borderColor,
        borderColor = _b === void 0 ? '#b3b3b3' : _b,
        _c = _a.borderWidth,
        borderWidth = _c === void 0 ? 0 : _c,
        _d = _a.borderStyle,
        borderStyle = _d === void 0 ? 'solid' : _d,
        _e = _a.arrowSize,
        arrowSize = _e === void 0 ? 8 : _e,
        _f = _a.bubbleProps,
        bubbleProps = _f === void 0 ? {} : _f,
        _g = _a.arrowProps,
        arrowProps = _g === void 0 ? {} : _g,
        _h = _a.bubbleStyle,
        bubbleStyle = _h === void 0 ? {} : _h,
        _j = _a.arrowStyle,
        arrowStyle = _j === void 0 ? {} : _j,
        _k = _a.style,
        style = _k === void 0 ? {} : _k,
        bubbleBorderWidth = _a.bubbleBorderWidth,
        arrowBorderWidth = _a.arrowBorderWidth,
        bubbleBorderColor = _a.bubbleBorderColor,
        arrowBorderColor = _a.arrowBorderColor,
        bubbleBorderStyle = _a.bubbleBorderStyle,
        arrowBorderStyle = _a.arrowBorderStyle;
    return react_1.default.createElement(react_popper_1.Manager, null, react_1.default.createElement(react_popper_1.Reference, null, function (_a) {
      var ref = _a.ref;
      return react_1.default.cloneElement(children, {
        ref: ref,
        onMouseEnter: function onMouseEnter() {
          return _this.setState({
            tooltip: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this.setState({
            tooltip: false
          });
        }
      });
    }), react_1.default.createElement(react_popper_1.Popper, {
      placement: preferredPlacement,
      modifiers: {
        computeStyle: {
          gpuAcceleration: false
        }
      }
    }, function (_a) {
      var ref = _a.ref,
          popperArrowProps = _a.arrowProps,
          popoverProps = __rest(_a, ["ref", "arrowProps"]);

      return react_1.default.createElement(base_ui_1.Content, __assign({
        arrowSize: arrowSize,
        borderColor: borderColor,
        bubbleBorderColor: bubbleBorderColor,
        arrowBorderColor: arrowBorderColor,
        borderWidth: borderWidth,
        bubbleBorderWidth: bubbleBorderWidth,
        arrowBorderWidth: arrowBorderWidth,
        borderStyle: borderStyle,
        bubbleBorderStyle: bubbleBorderStyle,
        arrowBorderStyle: arrowBorderStyle,
        arrowProps: arrowProps,
        arrowStyle: arrowStyle,
        bubbleStyle: bubbleStyle,
        bubbleProps: bubbleProps,
        passRef: ref,
        visible: _this.state.tooltip,
        commonStyle: style,
        popperArrowProps: popperArrowProps
      }, popoverProps), tip);
    }));
  };

  return default_1;
}(react_1.default.Component);

exports.default = default_1;